import { useContext, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router";
import StructuredLessonItem from "../../components/StructuredLessonItem";
import { UserContext } from "../../providers/UserProvider";

function YearSelectionPage() {
  const { setYear } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Daly Exercise+ | Year Group";
  }, []);

  const goToLesson = (id, year, updatedLessons = false) => {
    setYear(year);
    navigate("/curriculum");
    // navigate("/dashboard")
  };

  const yearData = [
    {
      title: "Junior & Senior",
      content: "Junior & Senior",
      id: "ScyF4p5IWmW0W1nN3jdu",
      color: "green",
      year: 0,
      icon: "icon_infants"
    },
    {
      title: "1st & 2nd",
      content: "1st & 2nd",
      id: "ltmdjbUAhX827TpQZrbq",
      color: "red",
      year: 1,
      icon: "icon_1st_2nd"
    },
    {
      title: "3rd & 4th",
      content: "3rd & 4th",
      id: "33w5lRGDmjeDbiZhVvuI",
      color: "yellow",
      year: 2,
      icon: "icon_3rd_4th"
    },
    {
      title: "5th & 6th",
      content: "5th & 6th",
      id: "Lr9JFFnnTg8KY5forR28",
      color: "purple",
      year: 3,
      icon: "icon_5th_6th"
    },
    {
        title: "Mild SEN",
        content: "Mild SEN",
        id: "ScyF4p5IWmW0W1nN3jdu",
        color: "textPrimary",
        year: 10,
        icon: "icon_sen_mild"
      },
      {
        title: "Moderate SEN",
        content: "Moderate SEN",
        id: "ltmdjbUAhX827TpQZrbq",
        color: "tiktokColour",
        year: 11,
        icon: "icon_sen_moderate"
      },
      {
        title: "Severe-Profound SEN",
        content: "Severe-Profound SEN",
        id: "33w5lRGDmjeDbiZhVvuI",
        color: "blue",
        year: 12,
        icon: "icon_sen_severe"
      },
  ];


  return (
    <Container fluid>
      <div className="dashboard-body">
        <Container>
          <h1 className="pageTitle title-margin">Class Groups</h1>
          <br />
          <Row className="structured-lesson-list-container justify-content-center">
            {yearData.map(({ title, content, id, color, year, icon }) => (
              <Col key={id} md={3}>
                <StructuredLessonItem
                  title={title}
                  content={content}
                  icon={icon}
                  click={() => goToLesson(id, year, true)}
                  color={color}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </Container>
  );
}

export default YearSelectionPage;
